
export class SelectListItem {
    Id?: string;
    CompanyId?: string;
    Type?: string;
    TranslatedType?: string;
    Value?: string;
    TaskType?: string;
    Position: number;
    Modifier?: string;
    Modified?: string;

    constructor(Type: any, TranslatedType: string, public allowCustomOrdering: boolean = true) {
        this.Type = Type;
        this.TranslatedType = TranslatedType;
    }
}

export enum ListType {
    TenderingSubType = 'TenderingSubType',
    TenderingContractForm = 'TenderingContractForm',
    TenderingPriceRange = 'TenderingPriceRange',
    TenderingPriceBreakdown = 'TenderingPriceBreakdown',
    WorksitePriority = 'WorksitePriority',
    WorksiteSubtype = 'WorksiteSubtype',
    PlanSubtype = 'PlanSubtype',
    PlanPriority = 'PlanPriority',
    ExternalSystem = 'ExternalSystem',
    SuppliersDelayReasonCode = 'SuppliersDelayReasonCode',
    OrderersDelayReasonCode = 'OrderersDelayReasonCode',
    PlanDefaultAttachmentFolder = 'PlanDefaultAttachmentFolder',
    WorksiteDefaultAttachmentFolder = 'WorksiteDefaultAttachmentFolder',
    ExternalUnitImportTargetType = 'ExternalUnitImportTargetType',
    PaymentTerms = 'PaymentTerms',
    TransferReasonCode = 'TransferReasonCode'
}
